import ThumbtackPro from '../thumbtackpro/thumbtackpro.vue';
import sortBy from 'lodash/sortBy';

export default {
    name: 'thumbtack-results-list',
    props: ['providers', 'query'],
    components: {
        ThumbtackPro
    },
    data() {
        return {
            resultsExpanded: false,
            sorting: 'num_reviews',
            sortOptions: {
                num_reviews: { label: "# of reviews", direction: -1 },
                rating: { label: "Rating", direction: -1 },
            }
        }
    },
    computed: {
        results() {
            const providers = sortBy(this.providers, (pro) => pro[this.sorting] * this.sortOptions[this.sorting].direction);
            console.log(providers);
            if(providers.length > 4 && !this.resultsExpanded) {
                return providers.slice(0, 4);
            }
            return providers;
        }
    },
    methods: {
        expandResults() {
            this.resultsExpanded = true;
        }
    },
    watch: {
        providers(){
            /* Reset sorting */
            this.sorting = 'num_reviews';
            this.resultsExpanded = false;
        }
    }

};
